import { IContextualMenuItem } from "@fluentui/react";
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../src/taskpane/components/_v2/redux/storeMain";
import { ComponentTypes } from "../../../src/taskpane/config/config";
import { OneNoteProgId, SharePointFolderContentTypeIds } from "../../../src/taskpane/config/constants";
import { LanguageContext } from "../../../utilities/LocalizationModule";
import { menuItemIconStyles } from "../../../src/taskpane/config/controlStyles";
import { Stack20Regular } from "../../../src/taskpane/components/_v2/components/SvgIcons/Stack20Regular";

export function useMenuItem_VersionHistory(selectedItems: any[], waitFor: boolean, setShowVersionHistoryDialog: (showVersionHistoryDialog: boolean) => void, isInOneDrive: boolean) {
    const languageStrings = React.useContext(LanguageContext);

    const currentDirectory = useSelector((state: RootState) => state.workingDirectories.workingDirectories.length > 0 ? state.workingDirectories.workingDirectories[state.workingDirectories.workingDirectories.length - 1] : null);

    const onVersionHistoryClick = React.useCallback(() => {
        setShowVersionHistoryDialog(true);
    }, [setShowVersionHistoryDialog]);

    const menuItem_VersionHistory = React.useMemo(() => {
        const hasSingleSelection = selectedItems?.length === 1;
        if (!hasSingleSelection) {
            return null;
        }

        const selectedItem = selectedItems[0];

        const isNotSharePointList = currentDirectory?.type !== ComponentTypes.SharePointList;

        const isNotFolderOrOneNote = !selectedItem.ContentTypeId?.startsWith(SharePointFolderContentTypeIds.folder) &&
            selectedItem.ProgId !== OneNoteProgId;

        const userCanViewVersions = selectedItem.EffectiveBasePermissions?.canViewVersions;

        if (isNotSharePointList && isNotFolderOrOneNote && userCanViewVersions) {
            return {
                key: 'versions',
                disabled: waitFor === true,
                text: languageStrings.VersionHistory,
                // iconProps: { iconName: "History" },
                iconProps: {},
                onRenderIcon: () => <Stack20Regular className={menuItemIconStyles} />,
                onClick: onVersionHistoryClick,
            } as IContextualMenuItem;
        }

        return null;

    }, [selectedItems, waitFor, currentDirectory, languageStrings, onVersionHistoryClick]);

    return {
        menuItem_VersionHistory
    };
}